export default __webpack_public_path__ + "static/pic02-272823e0e4dc5add88636dc510e4eb02.jpg";